import React, { Component } from "react";
import { NavLink } from "react-router-dom";
// Components
import CreateClan from "../popup/CreateClan";
import ScrollingText from "../common/ScrollingText/ScrollingText";
import ClanIcon from "../../images/icon/clanIcon";
// Style
import { Modal } from "react-bootstrap";
// Services
import ClanApis from "../../helper/clan.api";
import AuthApis from "../../helper/auth.api";
// Utils
import { profile } from "../../utils/localstorage.utils";
import { errorHandler, updateLoader, getWebData } from "../../utils/common.utils";
import { getToken } from "../../utils/localstorage.utils";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
// Assets
import { IoIosCloseCircleOutline } from "react-icons/io";

export default class Clan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openCreateClan: false,
      clans: [],
      currentUser: profile()?.id,
      toggleEmail: false,
      bioLimit: 100,
      clanDetailsFetched: false,
    };

    this.clanApi = new ClanApis();
    this.authUser = profile();
    this.authApi = new AuthApis();
  }

  componentDidMount() {
    this.props.showOrHideNav(true);
    this.getData();
  }

  setWebsiteData = res => {
    this.setState({ websiteData: res[0] });
  };

  onClickOpenCreateClan = () => {
    if (this.authUser?.block) {
      toast.warning("You cannot perform this action as you are blocked by Espotz Admin");
      return false;
    }
    if (this.authUser.email) {
      if (this.authUser.isEmailVerified) {
        this.setState({
          openCreateClan: true,
        });
      } else {
        this.props.openPolicies(true);
      }
    } else {
      this.setState({ toggleEmail: true });
    }
  };

  // Updated email address
  updateEmail = val => {
    const data = {
      email: val.email,
    };

    updateLoader(true);

    this.authApi
      .updateProfile(data)
      .then(response => {
        localStorage.setItem(
          "login",
          JSON.stringify({
            login: true,
            token: getToken(),
            authUser: {
              user: response.data.result,
            },
          })
        );
        this.setState({ toggleEmail: false });
        updateLoader(false);
        toast.success("Email updated successfully !!");
      })
      .catch(reason => {
        updateLoader(false);
        errorHandler(reason, this.props.logout);
      });
  };

  // Close clan creation modal
  onClickCloseCreateClan = () => {
    this.setState({
      openCreateClan: false,
    });
  };

  // Open create new clan
  onClanCreated = val => {
    this.setState({
      openCreateClan: false,
    });
    this.getData();
  };

  // Fetch list of clans
  getData() {
    updateLoader(true);

    this.clanApi
      .getClans()
      .then(res => {
        var data = res.data["result"];
        this.setState({
          clans: data,
          clanDetailsFetched: true,
        });
        updateLoader(false);
      })
      .catch(err => {
        this.setState({ clanDetailsFetched: true });
        updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  }

  // Display welcome screen when no clans
  renderWelcomeScreen = () => {
    return (
      <div
        className="empty-state-container d-flex flex-column align-items-center justify-content-center py-5"
        style={{
          minHeight: "70vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Main content */}
        <div className="text-center px-4" style={{ position: "relative", zIndex: 1 }}>
          <div className="mb-4">
            <ClanIcon
              color="#ffffff"
              size="120px"
              style={{
                filter: "drop-shadow(0 0 10px rgba(255,255,255,0.3))",
                marginBottom: "20px",
              }}
            />
          </div>

          <h1
            className="display-4 fw-bold text-white mb-3"
            style={{
              fontSize: "2.5rem",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            Welcome to Clans
          </h1>

          <p
            className="text-white-50 mb-5 fs-18 fw-400"
            style={{
              maxWidth: "600px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            Create your own clan or join existing ones to connect with fellow players, compete in
            tournaments, and build your gaming legacy.
          </p>

          <div className="d-grid gap-3" style={{ maxWidth: "300px", margin: "0 auto" }}>
            <button
              type="button"
              className="btn btn-primary btn-lg fw-bold px-4 py-3"
              onClick={this.onClickOpenCreateClan}
              style={{
                background: "linear-gradient(45deg, #4a90e2 0%, #67b26f 100%)",
                border: "none",
                borderRadius: "12px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.25)";
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.2)";
              }}
            >
              Create Your Clan
            </button>

            <p className="text-white-50 mt-3 mb-0 fs-14 fw-400">
              Start your journey today and build your gaming community!
            </p>
          </div>
        </div>
      </div>
    );
  };

  renderClanCard = (clan, index) => {
    const { _id, name, logo, isActive } = clan;

    return (
      <div className="col-6 col-md-3 col-lg-2 my-2" key={index}>
        <NavLink to={`/clan/view/${_id}`}>
          <div
            className={`clan-card ${isActive ? "" : "epz-clan-deactivate"}`}
            style={{
              backgroundImage: "none",
              position: "relative",
              overflow: "hidden",
              borderRadius: "10px",
              height: "160px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {/* Using ClanIcon component as fallback when no logo is available */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "120px",
                zIndex: 0,
              }}
            >
              {logo?.url ? (
                <img
                  src={logo.url}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  alt={`${name} logo`}
                />
              ) : (
                <ClanIcon
                  color="#ffffff"
                  size="100%"
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "20px",
                    background: "linear-gradient(to bottom, #f55d5d 0%, black 100%)",
                  }}
                />
              )}
            </div>

            {!isActive && (
              <div className="d-flex justify-content-center">
                <p className="deactivated bg-dark text-white fw-600 px-2 py-2 rounded-10 position-relative mt-7 z-1">
                  Deactivated
                </p>
              </div>
            )}

            <div
              className="clan-card-name text-center px-2 py-2 fs-14 text-white fw-500 mt-auto w-100"
              style={{
                background: "rgba(0,0,0,0.7)",
                position: "relative",
                zIndex: 1,
                margin: 0,
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                height: "40px",
              }}
            >
              {name?.length <= 12 ? (
                <h5 className="fs-16 fs-lg-20 fw-600 text-white text-truncate mb-0">{name}</h5>
              ) : (
                <ScrollingText
                  text={name}
                  className="fs-16 fs-lg-20 fw-600 text-white"
                  separator="$$"
                />
              )}
            </div>
          </div>
        </NavLink>
      </div>
    );
  };

  // Display clans with grid styling (similar to 3+ clans view)
  renderClansGrid = () => {
    const requiredObject = getWebData();
    const { clans } = this.state;

    return (
      <div className="row clan-grid justify-content-center g-3">
        <h1 className="fs-20 fs-lg-26 fw-bold text-white">Welcome to Clans</h1>
        <p className="fs-14 fs-lg-18 fw-500 text-white-50">
          {requiredObject.INFORMATION_TEXT?.CLAN_ORG?.CLAN_DESCRIPTION ||
            "Join or create a clan to connect with other players."}
        </p>
        <div className="row justify-content-center">
          <div className="col-12 col-md-6 col-lg-3">
            <div className="d-grid my-4">
              <button
                className="create-clan-button pink-skyblue-gradient-btn flat-btn wallet-btn fw-bold py-2 px-4 text-white border-0"
                onClick={this.onClickOpenCreateClan}
              >
                Create Clan
              </button>
            </div>
          </div>
        </div>
        {clans.map((clan, index) => this.renderClanCard(clan, index))}
      </div>
    );
  };

  // Main render method for clans content
  getClansList = () => {
    const { clanDetailsFetched, clans } = this.state;

    if (!clanDetailsFetched) {
      return null; // Loading state
    }

    return clans.length === 0 ? this.renderWelcomeScreen() : this.renderClansGrid();
  };

  render() {
    const { openCreateClan, toggleEmail } = this.state;
    const clanList = this.getClansList();

    return (
      <div>
        {/* List of clans */}
        <section className="body-section clan-page">
          <div className="container p-3 mt-3 mt-lg-5">{clanList}</div>
        </section>

        {/* Create new clan modal */}
        <Modal show={openCreateClan} centered dialogClassName="create-clan-modal">
          <Modal.Body>
            <CreateClan
              openCreateClan={openCreateClan}
              onClickCloseCreateClan={this.onClickCloseCreateClan}
              onClickOpenCreateClan={this.onClickOpenCreateClan}
              onClanCreated={this.onClanCreated}
              updateLoader={updateLoader}
            />
          </Modal.Body>
        </Modal>

        {/* Verify Email modal */}
        <Modal show={toggleEmail} centered dialogClassName="CreateClan-modal">
          <Modal.Body>
            <div className="">
              <IoIosCloseCircleOutline
                className="close-icon position-absolute"
                onClick={() => {
                  this.setState({ toggleEmail: false });
                }}
                style={{ top: "10px", right: "10px" }}
              />
              <div className="text-white fw-400 mt-5 text-center">
                There is no email linked with your account. Please enter your email and verify it to
                proceed.
              </div>
              <Formik
                initialValues={{
                  email: "",
                }}
                validationSchema={Yup.object({
                  email: Yup.string().email("Invalid Email").required("Email is required"),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => {
                    this.updateEmail(values);
                    setSubmitting(false);
                  }, 400);
                }}
              >
                <Form className=" m-3" autoComplete="off">
                  <div className="">
                    <label htmlFor="email" className="fs-16 fw-600 text-white">
                      Email
                    </label>
                    <Field
                      name="email"
                      type="text"
                      placeholder="Enter Email"
                      autoComplete="off"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-5 text-white height-45"
                    />
                    <ErrorMessage
                      component="span"
                      className="error-msg"
                      name="email"
                      autoComplete="off"
                    />
                  </div>

                  <button
                    type="submit"
                    className="white-flat-btn fw-bold py-2 px-4 m-auto mb-2 d-block mt-4"
                  >
                    Add
                  </button>
                </Form>
              </Formik>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
